import { render, staticRenderFns } from "./surroundingTab.vue?vue&type=template&id=068ae000&scoped=true&"
import script from "./surroundingTab.vue?vue&type=script&lang=js&"
export * from "./surroundingTab.vue?vue&type=script&lang=js&"
import style0 from "./surroundingTab.vue?vue&type=style&index=0&id=068ae000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ae000",
  null
  
)

export default component.exports